













import Component from "vue-class-component";
import Vue from "vue";
import Layout from "@/components/Layout.vue";
import { Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Animations = namespace("animations");
@Component({
  components: { Layout }
})
export default class Banner extends Vue {
  @Animations.State
  private brandAnimationStarted!: boolean;
  @Animations.Mutation
  private setBrandAnimationStarted!: (value: boolean) => void;

  @Prop()
  private onAnimate!: () => void;

  mounted() {
    setTimeout(() => {
      this.setBrandAnimationStarted(true);
    }, 250);
  }
}
